/** Blurring people and vehicles (V17): what it would hide. */

// what blurring would hide: a count of people or vehicles cannot be made on a video they are blurred in
const BLURRED_KINDS = new Set([
	'person',
	'people',
	'pedestrian',
	'human',
	'man',
	'woman',
	'child',
	'cyclist',
	'car',
	'vehicle',
	'truck',
	'bus',
	'van',
	'motorcycle',
	'motorbike',
	'bicycle',
	'bike',
	'tractor',
	'trailer',
]);

/** Whether what is counted is something blurring would hide ("car", "people", "find all vehicles"). */
export const countsBlurredKind = subject =>
	(subject || '')
		.toLowerCase()
		.split(/[^a-z]+/)
		.filter(Boolean)
		.some(w => [w, w.replace(/s$/, ''), w.replace(/es$/, '')].some(v => BLURRED_KINDS.has(v)));
